export { Slider, SliderProps } from './Slider';
